class TargetDateOutOfRangeError extends Error {
    constructor() {
        super('Target date can not be less than current date');
    }
}
export default TargetDateOutOfRangeError;
